import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-white text-base md:text-xl xl:text-2xl font-semibold px-2" }
const _hoisted_2 = { class: "card-content-row" }
const _hoisted_3 = { class: "card-content-row" }
const _hoisted_4 = {
  key: 0,
  class: "my-2"
}
const _hoisted_5 = { class: "entity-title" }
const _hoisted_6 = { class: "card-content-row" }
const _hoisted_7 = {
  key: 1,
  class: "my-2"
}
const _hoisted_8 = { class: "entity-title" }
const _hoisted_9 = { class: "card-content-row" }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "entity-title text-error-dark" }
const _hoisted_12 = { class: "card-content-row" }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "entity-title text-error-dark" }
const _hoisted_15 = { class: "card-content-row" }
const _hoisted_16 = {
  key: 4,
  class: "flex flex-col gap-1"
}
const _hoisted_17 = { class: "card-content-row" }
const _hoisted_18 = { class: "card-content-row" }
const _hoisted_19 = {
  key: 5,
  class: "card-content-row"
}


import {
  CalendarDayParams,
  ChineseCalendarAction,
  ChineseCalendarDate,
} from "@/types/calculators";
import DayCardComponent from "@/views/Calculators/ChineseCalendar/components/DayCardComponent.vue";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'DaySummaryCardComponent',
  props: {
    cardTitle: {},
    dayParams: {}
  },
  setup(__props: any) {



const { t } = useI18n();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DayCardComponent, null, {
    "card-title": _withCtx(() => [
      _createElementVNode("p", _hoisted_1, _toDisplayString(__props.cardTitle), 1)
    ]),
    "card-content": _withCtx(() => [
      _createElementVNode("p", _hoisted_2, [
        _createTextVNode(_toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-summary.pluses")) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.dayParams.actions
              .filter((a) => a.is_positive)
              .map((a) =>
                _unref(t)(`calculators.chinese-calendar.doing.${a.doing}`)
              )
              .join(", ")), 1)
      ]),
      _createElementVNode("p", _hoisted_3, [
        _createTextVNode(_toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-summary.minuses")) + " ", 1),
        _createElementVNode("span", null, _toDisplayString(__props.dayParams.actions
              .filter((a) => !a.is_positive)
              .map((a) =>
                _unref(t)(`calculators.chinese-calendar.doing.${a.doing}`)
              )
              .join(", ")), 1)
      ]),
      (__props.dayParams.officer !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(__props.dayParams.officer.name), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.dayParams.officer.desc), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.dayParams.lunar_mansion !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(__props.dayParams.lunar_mansion.name), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(__props.dayParams.lunar_mansion.desc), 1)
          ]))
        : _createCommentVNode("", true),
      (__props.dayParams.collisions !== undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dayParams.collisions, (collision, id) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "my-2",
                key: 'collision-' + id
              }, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(collision.name), 1),
                _createElementVNode("p", _hoisted_12, _toDisplayString(collision.desc), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (__props.dayParams.negative_sha.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dayParams.negative_sha, (negative_sha, id) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "my-2",
                key: 'negative-sha-' + id
              }, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(negative_sha.name), 1),
                _createElementVNode("p", _hoisted_15, _toDisplayString(negative_sha.desc), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (__props.dayParams.symbol_stars.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dayParams.symbol_stars, (star, id) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "my-2",
                key: 'star-' + id
              }, [
                _createElementVNode("p", {
                  class: _normalizeClass(["entity-title", {
              'text-error-dark': !star.is_positive,
              'text-success': star.is_positive,
            }])
                }, _toDisplayString(star.star), 3),
                _createElementVNode("p", _hoisted_17, _toDisplayString(star.desc), 1)
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_18, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-summary.moon-day", {
              moon_day: __props.dayParams.moon_day,
            })), 1)
      ]),
      (__props.dayParams.is_retrograde)
        ? (_openBlock(), _createElementBlock("p", _hoisted_19, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-summary.retrograde.prefix")), 1),
            _createTextVNode(" " + _toDisplayString(_unref(t)("calculators.chinese-calendar-day.day-summary.retrograde.content")), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})